module.exports = __webpack_public_path__ + "23975b82b157a270c5600d1c08bcbba9.pdf";